import { rem } from 'polished';
import styled from 'styled-components';

export const Fieldset = styled.fieldset`
  .mode {
    legend {
      font-size: ${rem(16)};
      font-weight: 500;

      & + div {
        margin: 0;
      }
    }

    ul {
      margin-top: ${rem(12)};
      display: flex;
      flex-flow: row;
      justify-content: space-between;
    }

    li {
      width: calc((100% - ${rem(16)}) / 2);
      margin: 0;
    }

    label {
      display: flex;
      flex-flow: row wrap;
      justify-content: center;
    }

    svg {
      margin-right: ${rem(8)};
    }

    small {
      width: 100%;
      margin-top: ${rem(12)};
      text-align: center;
      font-size: ${rem(12)};
      color: ${({ theme }) => theme.colors.book.eapService.small};
      font-weight: 400;
      display: block;
    }
  }

  .notes {
    margin-top: ${rem(12)};
    padding: ${rem(16)};
    font-size: ${rem(14)};
    line-height: 140%;
    border-radius: ${rem(12)};

    p {
      margin: 0;
    }
  }
`;
